import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-product-card-skeleton',
  templateUrl: './product-card-skeleton.component.html',
  styleUrls: [
    '../product-card.component.scss',
    'product-card-skeleton.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgxSkeletonLoaderModule,
  ],
})
export class ProductCardSkeletonComponent {
}
